import { actions as coreActions } from '@elab/core/store/core';
import { mapFormDispatchToEvents } from '@elab/components/connected/forms/Form';
import { COMPONENT_CONNECT, COMPONENT_DISCONNECT } from '@elab/core/utils/dynaReduxHelpers';

export const createDispatcher = ({ storeName, reducers, sagaFactory }) => (dispatch, ctx) => ({
    [COMPONENT_CONNECT]: () => {
        const store = storeName || ctx.storeName || ctx.formId;
        if (!store) return;

        dispatch(coreActions.addReducer(store, reducers));

        const saga = sagaFactory(ctx.formId);
        dispatch(coreActions.addSaga(store || ctx.formId, saga));
    },
    [COMPONENT_DISCONNECT]: () => {
        const store = storeName || ctx.storeName || ctx.formId;
        dispatch(coreActions.removeSaga(store));
        dispatch(coreActions.removeReducer(store));
    },
    ...mapFormDispatchToEvents(dispatch, ctx),
});
